import React, { useEffect, useRef, useState } from 'react';
import { generateCharacterSVG } from '../utils/characterSVG';
import { characterData } from '../data/characterData';

const Character = ({ character, color, accessory, isActive }) => {
  const characterRef = useRef(null);
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    if (characterRef.current) {
      const svg = generateCharacterSVG(character, color, accessory);
      characterRef.current.innerHTML = svg;
    }
  }, [character, color, accessory]);

  // 創建閃光效果
  useEffect(() => {
    if (isActive) {
      const newSparkles = Array.from({ length: 6 }, (_, i) => ({
        id: i,
        x: Math.random() * 200 + 20,
        y: Math.random() * 200 + 20,
        delay: Math.random() * 0.5
      }));
      setSparkles(newSparkles);

      const timer = setTimeout(() => {
        setSparkles([]);
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [isActive]);

  const charData = characterData[character];
  const bgEffect = charData?.bgEffect || '';

  return (
    <div className="relative flex justify-center items-center">
      {/* 背景效果 */}
      <div className={`absolute inset-0 rounded-3xl overflow-hidden ${bgEffect}`}>
        <div className={`absolute inset-0 transition-opacity duration-300 ${isActive ? 'bg-gradient-to-br from-purple-100/50 via-blue-100/40 to-pink-100/50 dark:from-purple-800/30 dark:via-blue-800/25 dark:to-pink-800/30' : 'bg-gradient-to-br from-purple-50/30 via-blue-50/20 to-pink-50/30 dark:from-purple-900/20 dark:via-blue-900/15 dark:to-pink-900/20'}`}></div>
        
        {/* 脈衝效果 */}
        {isActive && (
          <div className="absolute inset-0 rounded-3xl animate-pulse">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-400/20 to-pink-400/20 rounded-3xl"></div>
          </div>
        )}
      </div>

      {/* 角色本體 */}
      <div 
        ref={characterRef} 
        className={`character w-48 h-48 transition-all duration-300 relative z-10 ${isActive ? 'scale-110 animate-bounce' : 'scale-100'}`} 
        style={{ filter: isActive ? 'drop-shadow(0 0 20px rgba(147,51,234,0.6)) brightness(1.1)' : 'drop-shadow(0 0 10px rgba(0,0,0,0.1))' }}
      >
        {/* Character SVG will be inserted here */}
      </div>

      {/* 閃光粒子效果 */}
      {sparkles.map(sparkle => (
        <div 
          key={sparkle.id} 
          className="absolute w-2 h-2 bg-yellow-400 rounded-full animate-ping pointer-events-none z-20" 
          style={{ 
            left: `${sparkle.x}px`, 
            top: `${sparkle.y}px`, 
            animationDelay: `${sparkle.delay}s`,
            animationDuration: '0.8s'
          }}
        />
      ))}

      {/* 音符飄浮效果 */}
      {isActive && (
        <div className="absolute inset-0 pointer-events-none z-15">
          <div className="absolute top-10 left-10 text-2xl animate-float opacity-70">🎵</div>
          <div className="absolute top-20 right-8 text-xl animate-float opacity-60" style={{ animationDelay: '0.5s' }}>🎶</div>
          <div className="absolute bottom-16 left-16 text-lg animate-float opacity-50" style={{ animationDelay: '1s' }}>🎼</div>
        </div>
      )}
    </div>
  );
};

export default Character;